import { render, staticRenderFns } from "./LessonTypeDays.vue?vue&type=template&id=53860862&scoped=true&"
import script from "./LessonTypeDays.vue?vue&type=script&lang=js&"
export * from "./LessonTypeDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53860862",
  null
  
)

export default component.exports